/* src/app/shared/components/footer/footer.component.scss */
.fs-footer {
  padding: 35px 0 0 0;
  font-size: 12px;
}
.fs-footer-copyright {
  font-size: 0.75rem;
  letter-spacing: 1.57px;
  line-height: 19px;
  text-align: right;
}
.fs-footer-logo {
  height: 30px;
  margin-left: 30px;
}
.fs-footer-icons {
  cursor: pointer;
  height: 26px;
  margin-right: 10px;
}
.footer-social-icon {
  height: 20px;
  padding-left: 4px;
}
.spacer {
  flex: 1 1 auto;
}
/*# sourceMappingURL=footer.component.css.map */
